module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('bottom-toolbar'), _vm._v(" "), _c('div', {
    staticClass: "showSmallScreenOnly",
    class: _vm.colorBottomButton
  }, [(_vm.currentRole === 'simple') ? _c('f7-fab', {
    staticClass: "leftfav3 button-fab bottomButton floatingButtonToolbarBlank",
    on: {
      "click": _vm.OpenFormsPageContact
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "add"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.currentRole === 'group') ? _c('f7-fab', {
    staticClass: "leftfav3 button-fab bottomButton floatingButtonToolbarBlank",
    on: {
      "click": _vm.OpenFormsPageContactGroup
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "add"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('f7-fab', {
    staticClass: "leftfav2 bottomButton floatingButtonToolbarBlank",
    attrs: {
      "href": "/contact/import"
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "bullet_list"
    }
  })], 1), _vm._v(" "), _c('f7-fab', {
    staticClass: "leftfav button-fab bottomButton floatingButtonToolbarBlank",
    on: {
      "click": function($event) {
        return _vm.extractCSV(_vm.contacts, _vm.contactGroups)
      }
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "document_text"
    }
  })], 1), _vm._v(" "), (_vm.multipleContactsDelete.length > 0) ? _c('f7-fab', {
    staticClass: "button-fab bottomButton contactDeleteButtonPosition floatingButtonToolbarBlank",
    attrs: {
      "id": "contactDeleteButton"
    },
    on: {
      "click": _vm.deleteMultipleContacts
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "trash"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('page-nav-bar', {
    attrs: {
      "currentServiceName": "MoneyRoad",
      "popoverName": ".popoverContacts",
      "subNavTitle": _vm.contactListLabel,
      "menuAccess": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row rowBackgroundImage",
    class: _vm.colorBottomButton
  }, [_c('div', {
    staticClass: "row showLargeScreenOnly rowSearchBar"
  }, [(_vm.currentRole === 'simple') ? _c('div', [_c('button', {
    staticClass: "new-button milkyBlock boxRequest",
    on: {
      "click": _vm.OpenFormsPageContact
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "add"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.addLabel))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.currentRole === 'group') ? _c('div', [_c('button', {
    staticClass: "new-button milkyBlock boxRequest",
    on: {
      "click": _vm.OpenFormsPageContactGroup
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "add"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.addGrouplabel))])], 1)]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "new-button milkyBlock boxRequest"
  }, [_c('a', {
    staticClass: "new-button-color",
    attrs: {
      "href": "/contact/import"
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "bullet_list"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.importLabel))])], 1)]), _vm._v(" "), _c('button', {
    staticClass: "new-button milkyBlock pull-right",
    on: {
      "click": function($event) {
        return _vm.extractCSV(_vm.contacts, _vm.contactGroups)
      }
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "document_text"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.extract_csv')))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "contactButtonContainer",
    class: _vm.colorBottomButton
  }, [_c('f7-grid', {
    attrs: {
      "no-gutter": ""
    }
  }, [_c('f7-col', {
    staticClass: "pilotageTabController",
    attrs: {
      "width": "50"
    }
  }, [(_vm.currentRole === 'simple') ? _c('f7-link', {
    staticClass: "pilotageLink",
    class: _vm.getColor,
    attrs: {
      "tab-link": ".contactTab1",
      "active": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeCurrentRole('simple')
      }
    }
  }, [_vm._v(_vm._s(_vm.contactLabel))]) : _c('f7-link', {
    staticClass: "pilotageLink",
    attrs: {
      "tab-link": ".contactTab1",
      "active": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeCurrentRole('simple')
      }
    }
  }, [_vm._v(_vm._s(_vm.contactLabel))])], 1), _vm._v(" "), _c('f7-col', {
    staticClass: "pilotageTabController",
    attrs: {
      "width": "50"
    }
  }, [(_vm.currentRole === 'group') ? _c('f7-link', {
    staticClass: "pilotageLink",
    class: _vm.getColor,
    attrs: {
      "tab-link": ".contactTab2"
    },
    on: {
      "click": function($event) {
        return _vm.changeCurrentRole('group')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.groups_label')))]) : _c('f7-link', {
    staticClass: "pilotageLink",
    attrs: {
      "tab-link": ".contactTab2"
    },
    on: {
      "click": function($event) {
        return _vm.changeCurrentRole('group')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.groups_label')))])], 1)], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('f7-tabs', [_c('f7-tab', {
    staticClass: "contactTab1",
    attrs: {
      "active": ""
    }
  }, [_c('f7-searchbar', {
    staticClass: "webdatalist",
    attrs: {
      "cancel-link": "Cancel",
      "search-list": "#contacts-list",
      "placeholder": _vm.searchInLabel,
      "clear-button": true
    },
    on: {
      "searchbar:search": _vm.onSearch,
      "searchbar:clear": _vm.onClear
    }
  }), _vm._v(" "), _c('cm-contact-list', {
    attrs: {
      "filterBy": _vm.filterBy,
      "contacts": _vm.contacts
    }
  }), _vm._v(" "), _c('cm-pagination', {
    attrs: {
      "firstIndex": _vm.paginationObject.firstIndex,
      "maxResultsByPage": _vm.paginationObject.maxResults,
      "nbResultsTotal": _vm.paginationObject.nbResultsTotal,
      "refreshEvent": _vm.paginationObject.refresh
    }
  })], 1), _vm._v(" "), _c('f7-tab', {
    staticClass: "contactTab2"
  }, [_c('f7-searchbar', {
    staticClass: "webdatalist",
    attrs: {
      "cancel-link": "Cancel",
      "search-list": "#group-list",
      "placeholder": "Search in Groups"
    },
    on: {
      "searchbar:search": _vm.onGroupSearch,
      "searchbar:clear": _vm.onGroupClear
    }
  }), _vm._v(" "), _c('cm-contact-group-list', {
    attrs: {
      "filterBy": _vm.groupFilterBy,
      "contactGroups": _vm.contactGroups
    }
  }), _vm._v(" "), _c('cm-pagination', {
    attrs: {
      "firstIndex": _vm.paginationObjectGroup.firstIndex,
      "maxResultsByPage": _vm.paginationObjectGroup.maxResults,
      "nbResultsTotal": _vm.paginationObjectGroup.nbResultsTotal,
      "refreshEvent": _vm.paginationObjectGroup.refresh
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "toolbarPageBottomBlank"
  })], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7ac6d7f6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ac6d7f6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/contacts/CMContactsPage.vue
// module id = 1698
// module chunks = 2